export function safeDecode(value) {
  const text = value == null ? "" : String(value);
  try {
    return decodeURIComponent(text);
  } catch (e) {
    return text;
  }
}

/**
 * Public blog URLs use a lowercase hyphenated slug.
 * The API still stores the original slug, including a few legacy values
 * ("null", a leading space, spaces, and a "blog/" prefix).
 */
export function cleanBlogSlug(rawSlug, title) {
  let source = safeDecode(rawSlug).trim();
  const unusable = !source || /^(null|undefined)$/i.test(source);
  if (unusable) {
    source = title == null ? "" : String(title).trim();
  } else {
    source = source.replace(/^\/?blog\//i, "");
  }
  return source
    .toLowerCase()
    .replace(/&amp;/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
